import {useEffect, useState} from "react";
import {getEvent} from "../api/apiClient";

export const useEvent = (eventUuid, reloadTrigger) => {
    const [event, setEvent] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();
        const event = getEvent(eventUuid, abortController.signal);

        event
            .then(
                (data) => {
                    const event = data;

                    setEvent(event)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [eventUuid, reloadTrigger]);

    return {event : event};
};